import React from 'react'
import { Box, Typography } from '@mui/material'
import { TV_COLORS, neonText } from '../designSystem'

type PresenterPromptProps = {
  message: string
}

const PresenterPrompt = ({ message }: PresenterPromptProps) => (
  <Box
    sx={{
      marginBottom: '15px',
      border: '1px solid rgba(255,255,255,0.25)',
      borderRadius: 2,
      p: 1.5,
      background: 'rgba(0,0,0,0.3)',
      color: '#fff',
      fontFamily: 'Montserrat',
      boxShadow: '0 0 12px rgba(0,0,0,0.35)',
    }}
  >
    <Typography
      variant="subtitle2"
      sx={{ fontFamily: 'Bebas Neue', fontSize: 18, color: TV_COLORS.cyan, ...neonText(TV_COLORS.cyan) }}
    >
      👨‍🎤 Animateur
    </Typography>
    <Typography variant="body2">{message}</Typography>
  </Box>
)

export default PresenterPrompt
